export const TZ = "America/Chicago";
export const DAY_NAMES = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export const ctDate = (iso) => new Date(iso).toLocaleDateString("en-CA", { timeZone: TZ });
export const ctTime = (iso) => new Date(iso).toLocaleTimeString("en-US", { timeZone: TZ, hour: "numeric", minute: "2-digit" });
export const ctHHMM = (iso) => new Date(iso).toLocaleTimeString("en-GB", { timeZone: TZ, hour: "2-digit", minute: "2-digit" });
export const hhmmLabel = (t) => { const [h, m] = t.split(":").map(Number); return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`; };

const parseD = (s) => { const [y, m, d] = s.split("-").map(Number); return new Date(Date.UTC(y, m - 1, d)); };
export const fmtD = (dt) => dt.toISOString().slice(0, 10);
export const addDays = (s, n) => { const d = parseD(s); d.setUTCDate(d.getUTCDate() + n); return fmtD(d); };
export const weekday = (s) => (parseD(s).getUTCDay() + 6) % 7;
export const todayCT = () => new Date().toLocaleDateString("en-CA", { timeZone: TZ });
export const weekStart = (s) => addDays(s, -weekday(s));
export const monthGridStart = (s) => weekStart(`${s.slice(0, 7)}-01`);
export const dayLabel = (s, opts = { weekday: "short", month: "short", day: "numeric" }) => parseD(s).toLocaleDateString("en-US", { ...opts, timeZone: "UTC" });

// Build per-day buckets from the calendar API response.
export function bucket(cal, days) {
  const out = Object.fromEntries(days.map((d) => [d, { lessons: [], groups: [], blocks: [], openings: [], windows: [] }]));
  const put = (d, k, v) => out[d] && out[d][k].push(v);
  cal.lessons.forEach((l) => put(ctDate(l.start), "lessons", l));
  cal.group_sessions.forEach((g) => put(ctDate(g.start), "groups", g));
  cal.openings.forEach((o) => put(ctDate(o.start), "openings", o));
  cal.blocks.forEach((b) => {
    for (let d = ctDate(b.start); d <= ctDate(b.end); d = addDays(d, 1)) put(d, "blocks", b);
  });
  days.forEach((d) => {
    out[d].windows = cal.rules.filter((r) => r.weekday === weekday(d) && (!r.from_date || r.from_date <= d) && (!r.until || d <= r.until));
    const e = cal.effective?.[d];
    out[d].open = !!e && (e.hitting.length > 0 || e.pitching.length > 0);
  });
  return out;
}
